import { SHOW_ERROR, HIDE_ERROR } from '../constants';

const initialState = { show: false, message: '', title: '' };

const error = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ERROR:
      return Object.assign({}, state, { show: true }, action.error);
    case HIDE_ERROR:
      return { ...state, ...{ show: false, message: '', title: '' } };
    default:
      return state;
  }
};

export default error;



// WEBPACK FOOTER //
// ./src/reducers/error.js